function Hero() {
  return (
    <section className="relative overflow-x-hidden flex flex-row items-center justify-between lg:min-h-[50vh] p-6 lg:px-12 lg:pt-36 lg:pb-24">
      <img
        className="absolute w-full h-full object-cover z-10 top-0 left-0"
        src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/dokumenty-3.jpg"
        alt="Obowiązek informacyjny - Drzewus RODO"
      />
      <div className="w-full h-full object-cover z-20 absolute top-0 left-0 gradient-green-ltr"></div>
      <div className="flex flex-col items-start justify-center gap-2 z-30">
        <h1 className="text-3xl lg:text-6xl text-white">
          Obowiązek informacyjny
        </h1>
      </div>
    </section>
  );
}

export default Hero;
